var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#EEF3F8",
  d: "M0 0h16v11H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2150BC",
  d: "M0 0h9v7H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#DC251C",
  d: "M9 0h7v1H9zM9 2h7v1H9zM9 4h7v1H9zM9 6h7v1H9zM0 8h16v1H0zM0 10h16v1H0z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#C5D0EC",
  d: "M1 1h1v1H1zM3 1h1v1H3zM5 1h1v1H5zM7 1h1v1H7zM1 3h1v1H1zM3 3h1v1H3zM5 3h1v1H5zM2 4h1v1H2zM4 4h1v1H4zM6 4h1v1H6zM2 2h1v1H2zM4 2h1v1H4zM6 2h1v1H6zM7 3h1v1H7zM1 5h1v1H1zM3 5h1v1H3zM5 5h1v1H5zM7 5h1v1H7z"
})));
export default SvgUs;